import {useAppContext} from "../utils/AppContext";
import Footer from "../components/home/Footer";
import eric from "../assets/images/maze-eric.png"

const About = () => {
    const {
        isSmallScreen,
        screenSize,
    } = useAppContext();

    const contentContainer = (!screenSize)? "content-container" : `content-container content-container${screenSize}`;
    const supportScroll = (!screenSize)? "support-pages-scroll" : `support-pages-scroll support-pages-scroll${screenSize}`;
    const aboutContentContainer = (!screenSize)? "about-content-container" : `about-content-container about-content-container${screenSize}`;
    const sectionTitle = (!screenSize)? 'section-title' : `section-title section-title${screenSize}`;
    const supportItemContainer = (!screenSize)? 'support-item-container' : `support-item-container support-item-container${screenSize}`;
    const itemTitle = (!screenSize)? 'item-title' : `item-title item-title${screenSize}`;
    const regularTextLight = (!screenSize)? 'regular-text-light' : `regular-text-light regular-text-light${screenSize}`;
    const smallTextLight = (!screenSize)? 'small-text-light' : `small-text-light small-text-light${screenSize}`;
    const authorImage = (!screenSize)? 'author-image' : `author-image author-image${screenSize}`;

    return (
        <div className={contentContainer}>
            <div className={supportScroll}>
                <div className={aboutContentContainer}>
                    <h2 className={sectionTitle}>Helping Developers Build Better Landing Pages</h2>
                    <div className={supportItemContainer}>
                        <p className={smallTextLight}>I've been a designer and developer for almost 20 years. I've spent a lot of that time 
                        focused on ecommerce, redesigning stores from the ground up and getting deep into the world 
                        of conversions, copywriting, buyer psychology, and everything that makes a visitor trust and 
                        engage with a site. I'm actually fascinated by the power of a well-designed landing page 
                        to grab attention and drive action.</p>
                        <p className={smallTextLight}>Recently, I've seen how generic AI tools often fall short when it comes to generating truly 
                        effective landing page content. It felt like users were constantly modifying the results 
                        to get what they really needed. That's why I created Maze. I wanted a tool that could 
                        leverage AI, but in a way that was specifically trained for the nuances of tech and 
                        SaaS landing pages.</p>
                        <p className={smallTextLight}>Maze uses a custom trained AI model with thousands of high-converting examples, copy, 
                        and design elements. It's designed to help developers and entrepreneurs quickly create 
                        landing pages that are not only visually appealing, but also deeply effective at attracting 
                        users, building trust, and ultimately converting visitors into customers. My hope is that 
                        Maze helps you launch your ideas and validate your MVPs with confidence.</p>
                    </div>
                    <div className="author-container">
                            <img 
                                className={authorImage}
                                src={eric} 
                                alt="Eric De los Santos"
                            />
                        <div className="author-information">
                            <h2 className={itemTitle}>Eric De los Santos</h2>
                            <p className={isSmallScreen? smallTextLight : regularTextLight}>AI Design & Integration Specialist</p>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );

};

export default About;
